//
export default [
  {
    text: 'n°',
    value: 'invoice_number',
  },
  {
    text: 'rut',
    format: 'rut',
    value: 'pch_provider_rut',
  },
  {
    text: 'proveedor',
    value: 'pch_provider_business_name',
  },
  {
    text: 'ordenes de compra',
    align: 'center',
    value: 'pch_purchase_orders_ids',
    component: {
      type: "chip-list",
      props: {
        class: 'mx-auto',
        link: item => `/purchase_orders/${item}`,
      }
    },
  },
  {
    text: 'fecha de emisión',
    align: 'center',
    format: 'date',
    value: 'emission_date',
  },
  {
    text: 'total',
    align: 'center',
    classes: 'font-weight-medium',
    format: 'currency',
    value: 'total',
  },
  {
    text: 'Condición de pago', 
    align: 'center',
    value: 'pch_payment_condition_type',
  }
]
